export default "__VITE_ASSET__62cb47e5__"